import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EmailLoginBuilder } from './email-login.builder';
import {
  ITrackingAction,
  ITrackingObject,
  ITrackingProperties,
} from 'i2g-ng-tracking';
import {
  AlignmentEnum,
  IconSizesEnum,
  IIcon,
  IRouter,
  IFormFieldErrorMessages,
} from 'i2g-ng-ui';

export interface IEmailLoginInfo {
  email: string;
  password: string;
}

@Component({
  selector: 'app-email-login',
  templateUrl: './email-login.component.html',
  styleUrls: ['./email-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [EmailLoginBuilder],
})
export class EmailLoginComponent implements OnInit, OnChanges {
  @Input() disabled = false;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;
  @Input() trackingAdditionalProperties: ITrackingProperties;
  @Input() processing: boolean;

  @Output() buttonSubmit = new EventEmitter<IEmailLoginInfo>();

  formKeys: any;
  form: FormGroup;
  passwordErrorMessage: IFormFieldErrorMessages;
  forgotPasswordRoute: IRouter;
  alignmentEnum: typeof AlignmentEnum;
  spinnerIcon: IIcon;

  constructor(private _emailLoginBuilder: EmailLoginBuilder) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled && this.form) {
      if (this.disabled) {
        this.form.disable();
      } else {
        this.form.enable();
      }
    }
  }

  ngOnInit() {
    this.alignmentEnum = AlignmentEnum;
    this.spinnerIcon = {
      name: 'dotted-spinner',
      size: IconSizesEnum.custom,
    };
    this.forgotPasswordRoute = this._emailLoginBuilder.buildForgotPasswordRoute();

    this.formKeys = this._emailLoginBuilder.FORM_KEYS;
    this.form = this._emailLoginBuilder.buildForm();
    this.passwordErrorMessage = this._emailLoginBuilder.buildPasswordMinLengthErrorMessages();
  }

  get emailAddress() {
    return this.form.get(this.formKeys.EMAIL_ADDRESS);
  }

  get password() {
    return this.form.get(this.formKeys.PASSWORD);
  }

  submit() {
    if (this.form.invalid) {
      this.emailAddress.markAsDirty();
      this.password.markAsDirty();
      return;
    }

    const email = this.emailAddress.value;
    const password = this.password.value;
    this.buttonSubmit.emit({ email, password });
  }
}
